import { render, staticRenderFns } from "./CertidoesDash.vue?vue&type=template&id=7daa5166"
import script from "./CertidoesDash.vue?vue&type=script&lang=js"
export * from "./CertidoesDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports